/* Keep pointer autofocus quiet without blurring controls or changing dialog focus. */
(() => {
  'use strict';
  const root = document.documentElement;
  if (root.hasAttribute('data-duoo-input')) return;

  const setMode = (mode) => {
    if (root.dataset.duooInput !== mode) root.dataset.duooInput = mode;
  };
  const navigationKeys = new Set([
    'Tab', 'Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft',
    'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'
  ]);
  // A timer-driven login invitation is not evidence of keyboard navigation.
  setMode('pointer');
  document.addEventListener('pointerdown', () => setMode('pointer'), { capture: true, passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.isComposing || event.metaKey || event.ctrlKey || event.altKey) return;
    if (event.key === ' ' && event.target instanceof Element &&
        event.target.closest('input:not([type="button"]):not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]')) return;
    if (navigationKeys.has(event.key)) setMode('keyboard');
  }, true);
  // Assistive-technology activation can arrive without a preceding keydown.
  // Ignore scripted .click() calls used by the theme's pointer interactions.
  document.addEventListener('click', (event) => {
    if (event.isTrusted && event.detail === 0) setMode('keyboard');
  }, true);
})();
